export default __webpack_public_path__ + "static/media/frame.d26117a5.png";